import api from "@/lib/api";
import { toast } from "sonner";

export const EUR_KM = 1.95583;

export async function downloadExport(id, format) {
  try {
    const r = await api.get(`/porijeklo/${id}/export`, { params: { format }, responseType: "blob" });
    const cd = r.headers["content-disposition"] || "";
    const name = (cd.match(/filename="(.+)"/) || [])[1] || `Izjava_o_porijeklu.${format}`;
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.click();
    URL.revokeObjectURL(url);
  } catch (e) {
    toast.error("Greška pri preuzimanju dokumenta");
  }
}

export function computePorijeklo(doc) {
  const items = doc.items || [];
  const sa = items.filter((i) => i.has_origin);
  const bez = items.filter((i) => !i.has_origin);
  const sum = (arr) => Math.round(arr.reduce((a, b) => a + (Number(b.value) || 0), 0) * 100) / 100;
  const totSa = sum(sa);
  const totBez = sum(bez);
  const total = Math.round((totSa + totBez) * 100) / 100;
  const fcaEur = Number(doc.fca_eur) || 0;
  const fcaKm = Math.round(fcaEur * EUR_KM * 100) / 100;
  return { sa, bez, totSa, totBez, total, fcaEur, fcaKm, ratio: fcaKm ? totBez / fcaKm : 0 };
}

export const pct = (v) => `${(v * 100).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %`;
